export default __webpack_public_path__ + "static/media/9-min.4f651643.PNG";